import React from 'react';

const PartnerBrands: React.FC = () => {
  return (
    <section className="relative flex flex-col items-center justify-center min-h-screen bg-dark text-white px-4 py-16 overflow-hidden">
      {/* Spotlight gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-lighter via-dark to-dark opacity-70"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-dark via-dark-lighter to-dark opacity-50 animate-pulse-slow"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="inline-flex items-center justify-center bg-dark-light px-4 py-2 rounded-md mb-8">
          <svg className="w-5 h-5 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <span className="text-white text-xl tracking-wider">Partner Brands</span>
        </div>

        <h1 className="relative">
          <span className="text-6xl md:text-7xl lg:text-8xl font-bold block">
            <span className="text-primary relative inline-block drop-shadow-[0_0_25px_rgba(93,209,190,0.3)]">
              Coming Soon
            </span>
          </span>
        </h1>
        
        <p className="text-lg md:text-xl text-gray-300 mt-8 max-w-3xl mx-auto relative">
          We're curating an exclusive network of premium brands to provide you with the best shopping experience.
          Stay tuned for exciting partnerships!
        </p>
      </div>
    </section>
  );
};

export default PartnerBrands; 